import { FleetStationShow } from "../views/fleets/stations";
import UserCargoStats from "../views/stats/user-cargo-stats";
import UserCargoStatsShow from "../views/stats/user-cargo-stats-show";
import MapDrivers from "../views/map/map_drivers";
import AllDriverListView from "../views/map/all_driver_list_view";
import AllDriverListMap from "../views/map/all_driver_list_map";
import WaybillDrivingTrackMap from "../views/waybills/waybill_driving_track_map";
import { ThirdDataRequestCreatePage } from "../views/authorization/third-data-request-create";
import CommunicationListPage from "../views/communication/CommunicationListPage";
import CommunicationDetailPage from "../views/communication/CommunicationDetailPage";
import AgentLogPage from "../views/agent/agent_log_page";

export const customRoutes = [
  {
    path: "/stations/:fleetId/:stationId/show",
    component: FleetStationShow,
  },
  {
    path: "/users-cargo-stats",
    component: UserCargoStats,
  },
  {
    path: "/user-cargo-stats/:id",
    component: UserCargoStatsShow,
  },
  {
    path: "/map/drivers",
    component: MapDrivers,
  },
  {
    path: "/map/all-drivers",
    component: AllDriverListView,
  },
  {
    path: "/map/all-drivers-map",
    component: AllDriverListMap,
  },
  {
    path: "/waybills/:waybillId/driving-track/:shipperId",
    component: WaybillDrivingTrackMap,
  },
  {
    path: "/thirdDataRequests/create",
    component: ThirdDataRequestCreatePage,
  },
  {
    path: "/communication",
    component: CommunicationListPage,
  },
  {
    path: "/communication/:ticketId",
    component: CommunicationDetailPage,
  },
  {
    path: "/agentLogs",
    component: AgentLogPage,
  },
];
